import auth from "../../middlewares/auth";
export const lectureVideosRoute = [
  {
    path: '/lecture/lecture-video/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/lecture_video/LectureVideoList'),
    name: 'lecture_video_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/lecture-video/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/lecture_video/LectureVideoForm'),
    name: 'lecture_video_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/lecture-video/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/lecture_video/LectureVideoForm'),
    name: 'lecture_video_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];